import { AxiosResponse } from 'axios';
import { useHttpClient } from '../components/infra/httpClient.component';
import { FileResponse } from '../components/interfaces/FileResponse';

export const useSearchService = () => {
    const httpClient = useHttpClient();

    const search = (data: string): Promise<AxiosResponse<FileResponse[], any>> => {
        return httpClient.get(`search?term=${data}`);
    };

    const last = (): Promise<AxiosResponse<any, any>> => {
        return httpClient.get(`search/last`);
    };

    const generatePdf = (data: string): Promise<AxiosResponse<any, any>> => {
        return httpClient.get(`search/pdf?term=${data}`);
    };

    const report = (term: string, file: FileResponse): Promise<AxiosResponse<any, any>> => {
        return httpClient.post(`search/report`, { term, address: file.address });
    };

    return { search, last, generatePdf, report };
};
